import styled from 'styled-components';

import { NewStyleColor } from '../../../utils/styles-constants';

const PublishDate = styled('div')`
	margin-left: auto;
	border-radius: 6px;
	background-color: ${NewStyleColor.Blue400};
	font-weight: 400;
	font-size: 14px;

	&:not(:empty) {
		padding: 2px 10px;
	}
`;

export { PublishDate };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/ButtonPublish/styles.ts